import { render, staticRenderFns } from "./ViewCount.vue?vue&type=template&id=22d930ea&scoped=true"
import script from "./ViewCount.vue?vue&type=script&lang=js"
export * from "./ViewCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d930ea",
  null
  
)

export default component.exports